<template>
    <b-nav-item @click="$emit('click', $event)">
        <slot />
    </b-nav-item>
</template>

<script>
import { BNavItem } from 'bootstrap-vue'

export default {
    components: { BNavItem },
}
</script>